import React from "react";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../components/Error/Error";
import Loading from "../../components/Loading/Loading";
import { useData } from "../../context/DataProvider";
import { formatDate } from "../../utils/commonText";
import styles from "./ProjectsPage.module.scss";

export interface IProjectsPageItem {
  baslik: string;
  aciklama: string;
  projeYer: string;
  projeYil: string;
  projeIsbirlik: string;
  projeEkip: string;
  insaatAlan: string;
  kapakGorsel: string;
  yatayGorsel: string;
  temaTipId: string;
  projeFotolar: IProjeFotolar[];
  temaTipleriAdi: string;
  id: string;
  status: number;
  createdDate: string;
  updatedDate: string | null;
}

export interface IProjeFotolar {
  dosya: string;
  dosyaTip: string;
  sira: number;
  projeId: string;
  id: string;
  status: number;
  createdDate: string;
  updatedDate: string | null;
}

/* Mock data
const data: IProjectsPageItem[] = [
  {
    baslik:
      "Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod",
    aciklama: "deneme",
    projeYer: "deneme",
    projeYil: "2025-01-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme",
    projeEkip: "deneme",
    insaatAlan: "deneme",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Projeler/Yatay/ef3b1eba-9c1d-4eeb-9d88-0ea31af62f31.jpg",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2025-01-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik:
      "2Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod",
    aciklama: "deneme",
    projeYer: "deneme",
    projeYil: "2025-01-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme",
    projeEkip: "deneme",
    insaatAlan: "deneme",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Projeler/Yatay/ef3b1eba-9c1d-4eeb-9d88-0ea31af62f31.jpg",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2025-01-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik:
      "3Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod",
    aciklama: "deneme",
    projeYer: "deneme",
    projeYil: "2025-01-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme",
    projeEkip: "deneme",
    insaatAlan: "deneme",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Projeler/Yatay/ef3b1eba-9c1d-4eeb-9d88-0ea31af62f31.jpg",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2025-01-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme2",
    aciklama: "deneme2",
    projeYer: "deneme2",
    projeYil: "2024-09-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme2",
    projeEkip: "deneme2",
    insaatAlan: "deneme2",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Projeler/Yatay/ef3b1eba-9c1d-4eeb-9d88-0ea31af62f31.jpg",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2024-09-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme3",
    aciklama: "deneme2",
    projeYer: "deneme2",
    projeYil: "2024-09-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme2",
    projeEkip: "deneme2",
    insaatAlan: "deneme2",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Projeler/Yatay/ef3b1eba-9c1d-4eeb-9d88-0ea31af62f31.jpg",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2024-09-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme4",
    aciklama: "deneme2",
    projeYer: "deneme2",
    projeYil: "2024-09-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme2",
    projeEkip: "deneme2",
    insaatAlan: "deneme2",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Projeler/Yatay/ef3b1eba-9c1d-4eeb-9d88-0ea31af62f31.jpg",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2024-09-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme5",
    aciklama: "deneme2",
    projeYer: "deneme2",
    projeYil: "2024-09-06T09:56:11.0345586+03:00",
    projeIsbirlik: "deneme2",
    projeEkip: "deneme2",
    insaatAlan: "deneme2",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Projeler/Yatay/ef3b1eba-9c1d-4eeb-9d88-0ea31af62f31.jpg",
    temaTipId: "08eb1060-e585-4894-c496-08dd267b32b1",
    projeFotolar: [
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/b6c07b08-a608-4ce3-9907-fa95c4978ba7.jpg",
        dosyaTip: "image/jpeg",
        sira: 1,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya:
          "https://localhost:44358/images/Projeler/ProjeGorsel/60d5be3a-90e7-4adc-aebc-3935fcb904a0.jpg",
        dosyaTip: "image/jpeg",
        sira: 2,
        projeId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    temaTipleriAdi: "tema2",
    id: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
    status: 1,
    createdDate: "2024-09-06T09:56:11.0345586+03:00",
    updatedDate: null,
  },
];
*/

const ProjectsPage: React.FC = () => {
  const navigate = useNavigate();
  const { projeler: data, isLoading, error } = useData();

  if (isLoading) return <Loading />;
  if (error) return <ErrorModal message={error.message} />;

  const sortedItems = [...data].sort((a, b) => {
    const dateA = new Date(a.projeYil);
    const dateB = new Date(b.projeYil);
    return dateB.getTime() - dateA.getTime();
  });

  // Tarihleri gruplamak için bir nesne oluştur
  const groupedByDate = sortedItems.reduce((acc, item) => {
    const date = formatDate(item.projeYil).toUpperCase();
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(item);
    return acc;
  }, {} as Record<string, typeof sortedItems>);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>PROJELER</h1>

      <div className={styles.projectsContainer}>
        {Object.entries(groupedByDate).map(([date, items]) => (
          <div key={date} className={styles.dateGroup}>
            <div className={`${styles.tarih} ${styles.fixed}`}>{date}</div>
            {items.map((item) => (
              <div className={styles.projectWrapper} key={item.id}>
                <div className={styles.item}>
                  <div className={styles.imageContainer}>
                    <img
                      src={item.kapakGorsel}
                      alt={item.baslik}
                      onClick={() => navigate(`/projeDetay/${item.baslik}`)}
                    />
                  </div>
                  <h2
                    className={styles.projectTitle}
                    onClick={() => navigate(`/projeDetay/${item.baslik}`)}
                  >
                    {item.baslik}
                  </h2>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsPage;
